const GPT = () => {
  return <>test</>;
};

export default GPT;
